function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 172 13.453125 L 203 13.453125 L 203 361.453125 L 172 361.453125 Z M 172 13.453125 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 13.453125 172 L 361.453125 172 L 361.453125 203 L 13.453125 203 Z M 13.453125 172 "
})));

function SvgTaskAddButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.939148%,32.939148%,32.939148%)",
      fillOpacity: 1
    },
    d: "M 187.378906 361.363281 C 178.917969 361.363281 172.050781 354.5 172.050781 346.035156 L 172.050781 28.722656 C 172.050781 20.261719 178.917969 13.398438 187.378906 13.398438 C 195.84375 13.398438 202.707031 20.261719 202.707031 28.722656 L 202.707031 346.035156 C 202.707031 354.5 195.84375 361.363281 187.378906 361.363281 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.939148%,32.939148%,32.939148%)",
      fillOpacity: 1
    },
    d: "M 346.035156 202.707031 L 28.722656 202.707031 C 20.261719 202.707031 13.398438 195.84375 13.398438 187.378906 C 13.398438 178.917969 20.261719 172.050781 28.722656 172.050781 L 346.035156 172.050781 C 354.5 172.050781 361.363281 178.917969 361.363281 187.378906 C 361.363281 195.84375 354.5 202.707031 346.035156 202.707031 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAddButton);
export default __webpack_public_path__ + "static/media/task-add-button.e384e182.svg";
export { ForwardRef as ReactComponent };